import React from 'react';
import { ArrowUpRight, ArrowDownRight, Minus, Activity } from 'lucide-react';

// AuditSummaryCard — Sprint D item 3.6.
// Lighthouse score + trend arrow + view-report link. Hidden when no audit
// data is available (the audits API not having returned a result, e.g. on a
// fresh account).

function tone(score) {
  if (score == null) return 'gray';
  if (score >= 90) return 'lime';
  if (score >= 70) return 'amber';
  return 'red';
}

const TONE_CLASS = {
  lime:  'text-[#B0FC38]',
  amber: 'text-amber-300',
  red:   'text-red-400',
  gray:  'text-gray-300',
};

const TREND_ICON = { up: ArrowUpRight, down: ArrowDownRight, flat: Minus };

export default function AuditSummaryCard({ audit }) {
  if (!audit) return null;
  const t = tone(audit.score);
  const TrendIcon = TREND_ICON[audit.trend] || Minus;
  return (
    <div data-testid="audit-summary-card" className="rounded-2xl border border-white/[0.06] bg-white/[0.02] p-5">
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-wider text-gray-500 mb-2">
        <Activity className="w-3 h-3" />
        Last audit
      </div>
      <div className="flex items-baseline gap-2">
        <span className={`text-4xl font-bold ${TONE_CLASS[t]}`} data-testid="audit-score">{audit.score ?? '—'}</span>
        <span className="text-[12px] text-gray-500">/100</span>
        {audit.previous_score != null && (
          <span data-testid={`audit-trend-${audit.trend}`} className="ml-1 inline-flex items-center text-[11px] text-gray-400">
            <TrendIcon className="w-3 h-3" /> {audit.previous_score}
          </span>
        )}
      </div>
      {audit.id && (
        <a
          href={`/api/client/audits/${audit.id}/pdf`}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-3 inline-flex items-center gap-1 text-[12px] text-gray-300 hover:text-white"
        >
          View report <ArrowUpRight className="w-3 h-3" />
        </a>
      )}
    </div>
  );
}
